export var getWindowObject = function getWindowObject() {
  return typeof window !== 'undefined' && !!window ? window : undefined;
};
export var getPerformanceObject = function getPerformanceObject() {
  var _ref = getWindowObject() || {},
    performance = _ref.performance;
  return performance;
};
export var getPerformanceObserverObject = function getPerformanceObserverObject() {
  var _ref2 = getWindowObject() || {},
    PerformanceObserver = _ref2.PerformanceObserver;
  return PerformanceObserver;
};